export default __webpack_public_path__ + "static/media/Logo_h4e.d99d1c88.png";